import React from 'react'
import DataTable from '../../components/dataTable'

const List = () => {
  return (
    <div className='list'>
        <DataTable/>
    </div>
  )
}

export default List